import React, { Fragment } from 'react'

import { isWebView } from '../../../admin/actions/index'

import PropTypes from 'prop-types'
import classnames from 'classnames'
import Cookies from '../../../components/cookies'

const ErrorIcon = '/images/danger-icon.svg'

import Navbar from '../../../components/nav'
import Footer from '../../../components/footer'
import { withRouterConnectWrapper } from '../../../validator'
import BaseApp from './base-app'

class CitiesApp extends BaseApp {
    constructor(props) {
        super(props)

        this.state = {
            sendError: this.sendError,
            errorMessage: null,
            showError: false,
        }
    }

    static childContextTypes = {
        webview: PropTypes.bool,
        isMobile: PropTypes.bool,
    }

    getChildContext() {
        return {
            webview: isWebView(),
            isMobile: isWebView(),
        }
    }

    /**
     * Send error message handler
     *
     * @param {string} message
     */
    sendError = message => {
        this.setState({ errorMessage: message })
        process.nextTick(() => {
            this.setState({ showError: true })
            setTimeout(() => {
                this.setState({ showError: false })
            }, 5000)
        })
    }

    /**
     * Render error messages if is error message available
     *
     * @returns {XML|null}
     */
    renderErrorMessage = () => {
        if (this.state.errorMessage !== null) {
            return (
                <div
                    className={classnames({
                        'Alert-msg__error': true,
                        'Alert-msg__error-show': this.state.showError,
                    })}
                >
                    <div className="Alert-msg__error-content">
                        <img src={ErrorIcon} alt="Error ikona" />
                        {this.state.errorMessage}
                    </div>
                </div>
            )
        }
        return null
    }

    /**
     * Render whole web with all resources
     *
     * @returns {XML}
     */
    renderFullWeb = () => {
        const isWebV = isWebView()
        const { footerClass } = this.props

        return (
            <Fragment>
                {!isWebV && <Navbar />}

                <div className="d-flex flex-column flex-fill">
                    {React.Children.map(this.props.children, child => (
                        React.cloneElement(child, { ...this.state })
                    ))}
                </div>

                {!isWebV && <Footer footerClass={footerClass} />}

                {this.renderErrorMessage()}
                {!isWebV && <Cookies />}
            </Fragment>
        )
    }


    render() {
        return this.renderFullWeb()
    }
}

export default withRouterConnectWrapper(state => ({
    authedUser: state.auth.user,
    token: state.auth.tokens ? state.auth.tokens.access_token : null,
    login: state.app.login,
    auth: state.auth,
}))(CitiesApp)
